import { SparklesSolidV6 } from "@shared/v2/Icomoon";

interface GradientCardProps {
  useGradientBorder?: boolean;
}

const GRADIENT_TEXT =
  "tw-bg-[linear-gradient(270deg,#3270FA_-2.46%,#3270FA_47.37%,#6c36d9_99.15%)] tw-bg-clip-text tw-text-transparent";
const GRADIENT_BORDER =
  "tw-bg-[linear-gradient(270deg,#3270FA_-2.46%,#3270FA_47.37%,#6C36D9_99.15%)] tw-p-[1px] tw-rounded-[6px]";

const AiSparkleBanner: React.FC<GradientCardProps> = ({ useGradientBorder = true }) => {
  const wrapperClass = useGradientBorder ? GRADIENT_BORDER : "tw-rounded-[6px]";
  const cardClass = useGradientBorder ? "tw-rounded-[5px]" : "tw-rounded-[6px]";

  return (
    <div className={`tw-inline-block ${wrapperClass}`}>
      <div className={`tw-bg-white tw-px-[8px] tw-pt-[4px] tw-pb-[2px] ${cardClass}`}>
        <span className={`${GRADIENT_TEXT} tw-flex tw-items-center tw-gap-[6px] tw-text-12d`}>
          <SparklesSolidV6 className="tw-text-[#6C36D9]" /> AI will summarize recorded calls
        </span>
      </div>
    </div>
  );
};

export default AiSparkleBanner;
